import React from 'react';

let year = new Date().getUTCFullYear()

const Copyright = (props: any) =>
  <div {...props}>
    Copyright &copy; 2019{year > 2019 ? `-${year}` : ''}; All rights reserved
  </div>

export default Copyright